import { useState, useEffect } from "react";
import LinkImg from "../Images/Link - Corefit Plus ⏵ Untitled-design-11-1.png";
import { Link } from "react-router-dom";
import "../Components/Navbar.css";
import "./Footer.css";
import "../Components/Main1.css";
import Card from "react-bootstrap/Card";
import "./OurStudio.css";
import "./AdLandingPage.css";
import MainImg from "../Images/6.png";
import testimonialImg1 from "../Images/Sonarika Mahajan.jpg";
import testimonialImg2 from "../Images/Urvashi.jpg";
import testimonialImg3 from "../Images/Sanchit Duggal.jpg";
import testimonialImg4 from "../Images/Pragya Sharma.jpg";
import testimonialImg5 from "../Images/Manju Maheta.jpg";
import uspImg1 from "../Images/Classical and Contemporary Pilates.png";
import uspImg2 from "../Images/Cross studio session access.png";
import uspImg3 from "../Images/Flexible booking through app.png";
import uspImg4 from "../Images/Instructors trained by US Masters.png";
import uspImg5 from "../Images/Wide variety of classes.png";
import cardimg2 from "../Images/Greater Kailash 1 Our Studio Page.webp";
import nfcImg from "../Images/IMG_7250.jpg";
import cardimggk2 from "../Images/GK2.webp";
import cardimg from "../Images/Noida Picture Gallery/2.jpg";
import cardimg3 from "../Images/Greenpark Our Studio Page.webp";
import Whatsapp from "../Components/Whatsapp";

const LandingPage = () => {
  const carouselImages = [
    testimonialImg1,
    testimonialImg2,
    testimonialImg3,
    testimonialImg4,
    testimonialImg5,
  ];

  const uspImages = [uspImg1, uspImg2, uspImg3, uspImg4, uspImg5];

  const [visibleCount, setVisibleCount] = useState(3);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(window.innerWidth < 768 ? 1 : 3);
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const openGoogleForm = () => {
    window.open("https://forms.gle/4RGDTd1wiKSxLP1x9", "_blank");
  };

  const handleMap = (location) => {
    window.open(location, "_blank");
  };

  return (
    <>
      <Whatsapp />
      <div className="page">
        {/* 1. Header - Logo */}
        <div className="navbar">
          <div className="navbar-left">
            <Link to="/">
              <img src={LinkImg} alt="CorefitPlus" className="logo" />
            </Link>
          </div>
          <div className="navbar-right">
            <button onClick={openGoogleForm} className="header-trial-button">
              <i className="fa fa-phone" style={{ marginRight: "12px" }}></i>
              Request Callback
            </button>
          </div>
        </div>

        {/* 2. Banner */}
        <div className="banner">
          <div className="banner-overlay"></div>
          <img src={MainImg} alt="Pilates Studio" className="heroImage" />
          <div className="banner-text m2">Welcome to Corefit Plus</div>
        </div>
        {/* 3. Short Introduction */}

        <div className="Main" style={{ marginTop: "40px" }}>
          <button onClick={openGoogleForm} className="trial-button">
            Book Your Trial Now
          </button>
        </div>

        {/* 4. USP Section */}
        <section className="uspSection">
          <h2 className="uspHeading">Why Corefit Plus?</h2>
          <div className="uspGrid">
            {uspImages.map((num, index) => {
              const uspTexts = [
                "Classical and Contemporary Pilates",
                "Cross Studio Session Access",
                "Flexible Booking Through Our App",
                "Instructors Trained by US MASTERS",
                "Wide Variety of Classes - Pre / Post Natal, Red Light Mat Pilates and Hot Yoga Flow",
              ];

              return (
                <div key={index} className="uspCard">
                  <img
                    src={num}
                    alt={`USP ${index + 1}`}
                    className="uspImage"
                  />
                  <p className="uspText">{uspTexts[index]}</p>
                </div>
              );
            })}
          </div>
        </section>

        {/* 5. Embedded Video Section */}
        <section className="videoSection">
          {/* <h4 style={{ textAlign: "center", marginBottom: "30px" }}>
          <span className="writte1">Testimonials</span>
        </h4> */}
          <div className="videoWrapper">
            <iframe
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/c6ZmBmrMAC4?si=PR8rVP66b2zg8hUs"
              title="Corefit Plus Intro"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video"
            ></iframe>
          </div>
        </section>

        {/* 7. Locations */}
        <section>
          <div className="contentt-container">
            <p style={{ marginBottom: "40px" }}>
              {" "}
              <span className="loc-title">Our Locations</span>{" "}
            </p>
          </div>{" "}
          <div className="loc-container">
            <div className="loc">
              <div>
                <Card className="loc-card">
                  <Card.Img src={cardimg2} alt="xxx" />
                  <Card.Body>
                    <Card.Title style={{ fontWeight: "600" }}>
                      GREATER KAILASH I
                    </Card.Title>
                    <Link
                      onClick={() =>
                        handleMap("https://maps.app.goo.gl/kk6Js8KCeS8Q2tdU7")
                      }
                    >
                      <button>Visit</button>{" "}
                    </Link>{" "}
                  </Card.Body>
                </Card>
              </div>
              <div>
                <Card className="loc-card">
                  <Card.Img src={cardimg3} alt="xxx" />
                  <Card.Body>
                    <Card.Title style={{ fontWeight: "600" }}>
                      GREEN PARK
                    </Card.Title>
                    <Link
                      onClick={() =>
                        handleMap("https://maps.app.goo.gl/TD62ARSneSvC99Gt6")
                      }
                    >
                      <button>Visit</button>{" "}
                    </Link>{" "}
                  </Card.Body>
                </Card>
              </div>

              <div>
                <Card className="loc-card">
                  <Card.Img src={nfcImg} alt="xxx" />
                  <Card.Body>
                    <Card.Title style={{ fontWeight: "600" }}>
                      NEW FRIENDS COLONY
                    </Card.Title>
                    <Link
                      onClick={() =>
                        handleMap("https://maps.app.goo.gl/FSE8gd2XFos5NN7J6")
                      }
                    >
                      <button>Visit</button>{" "}
                    </Link>{" "}
                  </Card.Body>
                </Card>
              </div>
              <div>
                <Card className="loc-card">
                  <Card.Img src={cardimg} alt="xxx" />
                  <Card.Body>
                    <Card.Title style={{ fontWeight: "600" }}>NOIDA</Card.Title>
                    <Link
                      onClick={() =>
                        handleMap("https://maps.app.goo.gl/NKmXuxy8wRQfinXP7")
                      }
                    >
                      <button>Visit</button>{" "}
                    </Link>
                  </Card.Body>
                </Card>
              </div>
              <div>
                <Card className="loc-card">
                  <Card.Img src={cardimggk2} alt="xxx" />
                  <Card.Body>
                    <Card.Title style={{ fontWeight: "600" }}>
                      GREATER KAILASH II
                    </Card.Title>
                    <Link
                      onClick={() =>
                        handleMap("https://maps.app.goo.gl/aSePCK8XnbSrYsMs8")
                      }
                    >
                      <button>Visit</button>{" "}
                    </Link>{" "}
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </section>

        {/* 8. Footer */}
        <footer className="footer">
          <div id="contactus">
            <div className="footer-contactus">
              <div className="col1">
                <div className="core-logo">
                  <img src={LinkImg} alt="corefit-logo"></img>
                </div>
                <div className="brand-title">Corewellness Pvt. Ltd.</div>
                <h6
                  style={{
                    color: "white",
                    padding: "20px 0px 10px 0px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  FOLLOW US
                </h6>
                <div className="logo-block">
                  <div className="kiriyoga-logo">
                    <a href="https://www.facebook.com/corefit.plus1/">
                      <i
                        style={{ color: "white" }}
                        className="fa-brands fa-square-facebook fa-2x"
                      ></i>
                    </a>
                  </div>
                  <div className="aya-logo">
                    <a href="https://www.instagram.com/corefit.plus/">
                      {" "}
                      <i
                        style={{ color: "white" }}
                        className="fa-brands fa-instagram fa-2x"
                      ></i>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col3">
                <h6
                  style={{
                    color: "white",
                    fontWeight: "600",
                    fontSize: "15px",
                  }}
                >
                  CONTACT US
                </h6>
                <div className="brand-title">Email : info@corefitplus.com</div>
                <div className="brand-title">Phone : +91 84482 07775</div>
                <div className="brand-title">
                  Website:{" "}
                  <a
                    href="https://www.corefitplus.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "underline" }}
                  >
                    www.corefitplus.com
                  </a>
                </div>
              </div>
            </div>
            <div className="footer-copy">
              <div className="copy-right">
                <div className="copy-title">
                  ©2025-26 Corewellness Pvt. Ltd. All Rights Reserved.
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;
